import React, { useRef, useState } from 'react';
import { UploadCloud } from 'lucide-react';
import opsService from '../../../services/opsService';

export default function InvoiceUpload({ onUploaded }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const send = async (file) => {
    if (!file) return;
    if (file.type !== 'application/pdf') { setError('PDF files only'); return; }
    setBusy(true); setError(null);
    try {
      await opsService.uploadInvoice(file);
      onUploaded && onUploaded();
    } catch (e) {
      setError(e?.response?.data?.detail || 'Upload failed');
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  return (
    <div
      className="bg-surface-card rounded-card shadow-elevation-1 border border-dashed p-8 text-center"
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => { e.preventDefault(); send(e.dataTransfer.files?.[0]); }}
    >
      <UploadCloud className="w-8 h-8 mx-auto text-ink-muted mb-2" />
      <p className="text-ink-soft font-medium">Drop a supplier invoice PDF here</p>
      <p className="text-ink-muted text-small mb-3">or</p>
      <button
        onClick={() => inputRef.current?.click()}
        disabled={busy}
        className="px-4 py-2 bg-accent text-white rounded-lg hover:bg-accent-hover disabled:opacity-50"
      >
        {busy ? 'Uploading…' : 'Choose PDF'}
      </button>
      <input ref={inputRef} type="file" accept="application/pdf" className="hidden"
             onChange={(e) => send(e.target.files?.[0])} />
      {error && <p className="text-danger mt-3">{error}</p>}
    </div>
  );
}
